import { useMemo } from 'react';
import { SubscriptionState } from '../../../../types';
import StateListItem from './Item';

import './index.css';
import LoadingIcons from 'react-loading-icons';

interface Props {
  data: Array<SubscriptionState>;
  handleMove: (state: SubscriptionState) => void;
  handleStopAll: () => void;
  handleStartAll: () => void;
  isLoading: boolean;
}

const StateList = (props: Props) => {
  const { data, handleMove, handleStopAll, handleStartAll, isLoading } = props;

  const activeSubscriptionStates = useMemo(
    () => data.filter((b) => b.isActive),
    [data],
  );
  const nonActiveSubscriptionStates = useMemo(
    () => data.filter((b) => !b.isActive),
    [data],
  );

  if (
    isLoading &&
    !activeSubscriptionStates?.length &&
    !nonActiveSubscriptionStates?.length
  ) {
    return (
      <div className="states-loading">
        <LoadingIcons.Grid width={80} />
      </div>
    );
  }

  return (
    <div className="states-root">
      {activeSubscriptionStates?.length && (
        <>
          <div className="states-title-container">
            <p className="states-title">Active Subscriptions</p>
            <div className="states-stop-button-small" onClick={handleStopAll}>
              {isLoading ? (
                <p className="states-button-text-small">Stopping...</p>
              ) : (
                <p className="states-button-text-small">Stop All</p>
              )}
            </div>
          </div>
          <div className="states-list-container">
            {activeSubscriptionStates.map((state) => (
              <StateListItem
                key={state.botId}
                state={state}
                handleMove={handleMove}
              />
            ))}
          </div>
        </>
      )}

      {nonActiveSubscriptionStates?.length && (
        <>
          <div className="states-title-container">
            <p className="states-title">Non-Active Subscriptions</p>
            <div className="states-start-button-small" onClick={handleStartAll}>
              {isLoading ? (
                <p className="states-button-text-small">Starting...</p>
              ) : (
                <p className="states-button-text-small">Start All</p>
              )}
            </div>
          </div>
          <div className="states-list-container">
            {nonActiveSubscriptionStates.map((state) => (
              <StateListItem
                key={state.botId}
                state={state}
                handleMove={handleMove}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default StateList;
